module.exports = __webpack_public_path__ + "media/honey-icons/icon-sound-detected-077f9eab.svg";